import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { DashboardHeader } from '../../atoms';
import { AddCatalogData, DashContentFooter } from '../../molecules';
import { DashboardContext } from '../../../context';

function AddCatalogPdf() {
  const history = useHistory();
  const [dashData, setDashData] = useState({});  

  const handleBackClick = () => {
    history.push('/interstitial');
  };

  return (
    <DashboardContext.Provider value={{ dashData, setDashData }}>
      <div className='row no-gutters'>
        <div className='no-gutters dash-left-wrapper'>
          <DashboardHeader />
          <AddCatalogData handleBackClick={handleBackClick} />
          <DashContentFooter />
        </div>

      </div>

    </DashboardContext.Provider>
  );
}

export default AddCatalogPdf;
